import { render, staticRenderFns } from "./NumerosBipados.vue?vue&type=template&id=1956bf6d&scoped=true&"
import script from "./NumerosBipados.vue?vue&type=script&lang=js&"
export * from "./NumerosBipados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956bf6d",
  null
  
)

export default component.exports